  @if (hasLabel() && labelMode() === 'static') {
    <label
      [for]="inputId()"
      class="block mb-2 text-sm font-medium text-gray-700"
    >
      {{ label() }}
      @if (hasRequiredRule()) {
        <span class="text-red-500">*</span>
      }
    </label>
  }

  @if (labelMode() === 'float' && hasLabel()) {
    <p-floatlabel [variant]="filled() ? 'in' : 'on'">
      <ng-container *ngTemplateOutlet="datePickerTemplate"></ng-container>
      <label [for]="inputId()">
        {{ label() }}
        @if (hasRequiredRule()) {
          <span class="text-red-500">*</span>
        }
      </label>
    </p-floatlabel>
  } @else {
    @if (labelMode() === 'ifta' && hasLabel()) {
      <p-iftalabel>
        <ng-container *ngTemplateOutlet="datePickerTemplate"></ng-container>
        <label [for]="inputId()">
          {{ label() }}
          @if (hasRequiredRule()) {
            <span class="text-red-500">*</span>
          }
        </label>
      </p-iftalabel>
    } @else {
      <!-- No Label or Static (input only) -->
      <ng-container *ngTemplateOutlet="datePickerTemplate"></ng-container>
    }
  }

  @if (helpText() && !isInvalid()) {
    <small class="block mt-1 text-surface-500 dark:text-surface-400">
      {{ helpText() }}
    </small>
  }

  @if (showErrors() && isInvalid() && errorMessage()) {
    <small class="absolute block mt-1 text-red-500 dark:text-red-400 animate-fade-in">
      <i class="pi pi-exclamation-circle mr-1"></i>
      {{ errorMessage() }}
    </small>
  }

<ng-template #datePickerTemplate>
  @if (hasCustomIcon()) {
    <p-iconfield [class]="fluid() ? 'w-full' : ''">
      @if (icon()?.position === 'left') {
        <p-inputicon
          [class]="icon()?.icon"
          [class.cursor-pointer]="icon()?.clickable"
          (click)="onIconClick()"
        />
      }

      <ng-container *ngTemplateOutlet="datePickerElement"></ng-container>

      @if (icon()?.position === 'right') {
        <p-inputicon
          [class]="icon()?.icon"
          [class.cursor-pointer]="icon()?.clickable"
          (click)="onIconClick()"
        />
      }
    </p-iconfield>
  } @else {
    <ng-container *ngTemplateOutlet="datePickerElement"></ng-container>
  }
</ng-template>

<!-- DatePicker Element Template -->
<ng-template #datePickerElement>
  <p-datePicker
    [inputId]="inputId()"
    [ngModel]="value()"
    (ngModelChange)="onSelect($event)"
    [placeholder]="placeholder()"
    [disabled]="computedDisabled()"
    [readonlyInput]="readonly()"
    [selectionMode]="selectionMode()"
    [minDate]="computedMinDate()"
    [maxDate]="computedMaxDate()"
    [disabledDates]="disabledDates()"
    [disabledDays]="disabledDays()"
    [showTime]="showTime()"
    [timeOnly]="timeOnly()"
    [hourFormat]="hourFormat()"
    [showSeconds]="showSeconds()"
    [showButtonBar]="showButtonBar()"
    [showWeek]="showWeek()"
    [view]="view()"
    [showIcon]="showIcon() && !hasCustomIcon()"
    [iconDisplay]="iconDisplay()"
    [inline]="inline()"
    [numberOfMonths]="numberOfMonths()"
    [firstDayOfWeek]="firstDayOfWeek()"
    [variant]="filled() ? 'filled' : 'outlined'"
    [showClear]="showClear()"
    [fluid]="fluid()"
    [invalid]="isInvalid()"
    [attr.name]="name()"
    [attr.aria-describedby]="helpText() ? inputId() + '-help' : null"
    [attr.aria-invalid]="isInvalid()"
    (onFocus)="onFocus($event)"
    (onBlur)="onBlur($event)"
    (onClose)="onHide()"
    (onSelect)="onSelect($event)"
    (onClear)="onClear()"
    (onInput)="onInput($event)"
    (onShow)="onShow()"
    (onMonthChange)="onMonthChange($event)"
    (onYearChange)="onYearChange($event)"
    (onClickOutside)="onClickOutside()"
    [dateFormat]="dateDisplayFormat()"
    [autofocus]="autofocus()"
    [showOnFocus]="showOnFocus()"
    appendTo="body"
    class="relative"
  />
</ng-template>
